export const STATUS_PENDING = 0;
export const STATUS_ACCEPTED = 1;
export const STATUS_REFUSED = 2;
